import { gql } from '@apollo/client';

export const CRM_FORM_FIELDS = `
    _id
    name
    heading
    slug
    fields {
        key
        label
        fieldType
        required
        order
    }
    mapping {
        businessName
        contactFirstName
        contactLastName
        contactEmail
        contactPhone
    }
    defaultPipelineId
    defaultStageKey
    tags
    defaultLeadSource
    image
    backgroundColor
    confirmationHeading
    confirmationMessage
    status
    publicUrl
    embedSnippet
    createdAt
    updatedAt
`;

export const LIST_CRM_FORM_SUBMISSIONS = gql`
    query ListCrmFormSubmissions($formId: ID, $contactId: ID) {
        listCrmFormSubmissions(formId: $formId, contactId: $contactId) {
            _id
            formId
            formName
            createdAccountId
            createdContactId
            submittedAt
            answers {
                key
                label
                value
            }
        }
    }
`;

export const LIST_CRM_FORMS = gql`
    query ListCrmForms {
        listCrmForms {
            ${CRM_FORM_FIELDS}
        }
    }
`;

export const GET_CRM_FORM = gql`
    query GetCrmForm($id: String!) {
        getCrmForm(id: $id) {
            ${CRM_FORM_FIELDS}
        }
    }
`;
